/** @format */

import {styled} from '@mui/material/styles';
import {Box, Button, Typography, Autocomplete} from '@mui/material';

import {FilterOption} from './types';

export const FilterBarContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  padding: theme.spacing(3, 4),
  marginBottom: theme.spacing(2),
  backgroundColor: theme.palette.figma_gray_dark_1?.main,
  borderRadius: theme.spacing(1),
  border: `1px solid ${theme.palette.figma_gray_dark_3?.main}`,
  gap: theme.spacing(2),
  flexWrap: 'wrap',
}));

export const FiltersContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'flex-start',
  flexWrap: 'wrap',
}));

export const FilterContainer = styled(Box)(({theme}) => ({
  minWidth: '180px',
  maxWidth: '250px',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const FilterLabel = styled(Typography)(({theme}) => ({
  color: theme.palette.text.primary,
  fontSize: '14px',
  fontWeight: 500,
  marginBottom: theme.spacing(0.5),
}));

export const StyledAutocomplete = styled(Autocomplete<FilterOption>)(({theme}) => ({
  '& .MuiOutlinedInput-root': {
    backgroundColor: theme.palette.figma_gray_dark_2?.main,
    color: theme.palette.text.primary,
    borderRadius: theme.spacing(1),
    fontSize: '14px',
    padding: theme.spacing(0.5, 1),
  },
}));

export const ActionsContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  gap: theme.spacing(2),
  marginLeft: 'auto',
  flexShrink: 0,
}));

export const ResetButton = styled(Button)(({theme}) => ({
  whiteSpace: 'nowrap',
  minWidth: 'auto',
  color: theme.palette.text.primary,
  borderColor: theme.palette.action.active,
  backgroundColor: 'transparent',
  padding: theme.spacing(1, 2),
  fontSize: '14px',
  '&:hover': {
    borderColor: theme.palette.action.hover,
    backgroundColor: theme.palette.figma_gray_dark_3?.main,
  },
  '&.Mui-disabled': {
    color: theme.palette.action.disabled,
    borderColor: theme.palette.action.disabled,
    backgroundColor: 'transparent',
    opacity: 0.6,
  },
}));
